import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
// import { login } from "@/services/auth";

export default {
  name: "Login",
  data: function data() {
    return {
      isForceLogout: false
    };
  },
  head: {
    title: {
      inner: "ログイン"
    },
    meta: []
  },
  computed: {
    ttlJP: function ttlJP() {
      var ttl = 1000 * 60 * 60;
      var ttlJP = "一定時間";
      if (ttl) {
        ttl = ttl / 1000 / 60;
        ttlJP = ttl + "分";
      }
      return ttlJP;
    }
  },
  watch: {
    "$auth.isAuthenticated": function () {
      var _$authIsAuthenticated = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(v) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (v) {
                this.$router.push({
                  name: "Dashboard"
                });
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function $authIsAuthenticated(_x) {
        return _$authIsAuthenticated.apply(this, arguments);
      }
      return $authIsAuthenticated;
    }()
  },
  created: function created() {
    this.isForceLogout = !!localStorage.getItem("FORCE_LOGOUT");
  },
  methods: {
    handleLogin: function handleLogin() {
      this.$auth.loginWithRedirect();
    }
  }
};